const en = {
	wheight: 'Wheight',
	action: {
		label: 'Action | Actions',
		add: 'Add',
		added_in_enabled: '+ Actived',
		added_in_disabled: '+ Deleted',
		add_new: 'Add New | Add News',
		add_new_language: 'Add Language | Add Languages',
		all_profiles: 'All Profiles',
		archive: 'Archive',
		update_avatar: 'Update Avatar',
		category: 'Category | Categories',
		change: 'Change',
		comment: 'Comment',
		cancel: 'Cancel',
		confirm: 'Confirm',
		compare: 'Compare',
		compare_reatings: 'Compare Rating | Compare Ratings',
		compare_avarage_reatings: 'Compare Avarage Reating | Compare Avarage Reatingsg',
		copy: 'Copy',
		copy_url: 'Copy Url',
		create_account: 'Get Account',
		create_your_resume: 'Create Your Resume',
		create_free_account: 'Get Free Account',
		create_new_process: 'Create New Process',
		created: 'Created',
		close: 'Close',
		close_process: 'Close Process',
		delete: 'Delete',
		disable: 'Disable',
		end: 'End',
		edit: 'Edit',
		edit_user: 'Edit User',
		edit_product: 'Edit Product | Edit Products',
		enable: 'Enable',
		generate_link: 'Generate Link',
		generate_new_link: 'Generate New Link',
		filter: 'Filter',
		following: 'Following',
		inactive: 'Inactive',
		active: 'Active',
		include: 'Include',
		insert: 'Insert',
		insert_new: 'Insert New',
		move: 'Move',
		new_profile: 'New Profile',
		new_process: 'New Process',
		open: 'Open',
		print: 'Print',
		profile_added: 'Profile Added | Profiles Added',
		ready_more: 'Ready More',
		register: 'Register',
		register_financial_record: 'Register Financial | Register Financial',
		remove: 'Remove',
		remember: 'Remember',
		reload: 'Reload',
		start: 'Start',
		show: 'Show',
		show_in_menu: 'Display in main menu',
		show_detail: 'Show Detail | Show Datails',
		send: 'Send',
		select_file: 'Select File | Select Files',
		stock_in: 'Stock In',
		select: 'Select',
		select_image: 'Select a Image | Select Images',
		search: 'Search',
		stock_out: 'Stock Out',
		save: 'Save',
		saved: 'Saved | Saved',
		save_and_select: 'Salve and select',
		register_new: 'Register New',
		signup: 'Sign-up',
		signin: 'Sign-in',
		submit: 'Submit',
		upload: 'Upload',
		unselect: 'Unselect',
		back: 'Back',
		update: 'Update',
		unarchive: 'Unarchive',
		use: 'Use'
	},
	address: {
		label: 'Address | Addresses',
		street: 'Street | Streets',
		number: 'Number | Numbers',
		city: 'City | Cities',
		district: 'District | Districts',
		state: 'State | States',
		country: 'Country | Countries',
		complement: 'Complement | Complements',
		zip_code: 'Zip Code | Zip Code'
	},
	average_rating: 'Average Rating | Average Rating',
	all_my_tasks: 'All My Tasks',
	all_my_open_task: 'All my open task | All my open tasks',
	archived: 'Archived | Archived',
	account: 'Account | Accounts',
	all: 'All',
	all_processes: 'All Processes',
	all_profiles: 'All Profiles',
	avatar: 'Avatar | Avatars',
	academic: 'Academic | Academic',
	access_restriction: 'Access Restriction | Access Restrictions',
	avaliation_topic: 'Avaliation Topic | Avaliation Topics',
	avaliation_result: 'Avaliation Result | Avaliation Results',
	amount: 'Amount | Amounts',
	best: 'Best | Bests',
	by_profile_owner: 'By user profile owner | By users profiles owners',
	barcode: 'Barcode | Barcodes',
	best_up: 'Best Up | Bests Up',
	best_down: 'Best Down | Bests Down',
	basic_data: 'Basic Data | Basic Data',
	billing_email: 'Billing Email | Billing Emails',
	business_name: 'Business Name | Business Names',
	boolean: {
		yes: 'Yes',
		no: 'No'
	},
	candidate: 'Candidate | Candidates',
	closed_process: 'Closed Process | Closed Processes',
	closed: 'Closed | Closed',
	created_by: 'Created By',
	created_date: 'Created Date',
	cv: 'Resume | Resumes',
	curriculum_vitae: 'Curriculum Vitae | Curriculum Vitae',
	color: 'Color | Colors',
	customer: {
		label: 'Customer | Customers',
		name: 'Customer Name | Customer Names',
		main_name: 'Customer Main Name',
		code: 'Customer Code | Customer Codes',
		contact: 'Customer Contacts | Customer Contacts'
	},
	custom_features: 'Custom feature | Custom features',
	curriculum: 'Curriculum | curriculums',
	compare_profile: {
		label: 'Compare Profiles',
		desc: 'Define the evaluation criteria of the profiles and compare the results.'
	},
	competency_dossier: 'Competency Dossier | Competency Dossiers',
	current_period: 'Current Period',
	core: 'Core | Cores',
	core_skill: 'Core Skill | Core Skills',
	core_skill_not: 'Not Core Skill | Not Core Skills',
	code: 'Code | Codes',
	cost: 'Cost | Costs',
	context: 'Context | Contexts',
	country: 'Country | Countries',
	company: 'Company | Companies',
	company_name: 'Company Name | Company Names',
	certification: 'Certification | Certifications',
	city: 'City | Cities',
	current: 'Current | Currents',
	custom_label: 'Custom Label | Custom Labels',
	confirmed: 'Confirmed | Confirmed',
	canceled: 'Canceled',
	currency: {
		label: 'Currency | Currencies',
		euro: 'Euro | Euros',
		dolar: 'Dolar| Dolars',
		pound: 'Pound | Pounds',
		real: 'Real | Reals'
	},
	content: 'Content | Contents',
	no_content: 'No content | No contents',
	closing_date: 'Closing Date| Closing Date',
	closed_data: 'Closed Data|Closed Data',
	closed_with_delay: 'Closed with delay',
	closed_with_delay_explanation: 'Process closed after deadline',
	closed_in_time: 'Closed in time',
	closed_in_time_explanation: 'Process closed before deadline end',
	contact: {
		label: 'Contact | Contacts',
		request_contact: 'Request Contact',
		send_your_msn: 'Send your message',
		any_questions: `Any questions or clarifications?
						Send a message right now.`,
		suporte_contact: 'Suporte contact',
		if_prefer_send_email: `If you prefer, send a message to the support email`
	},
	done: 'Done | Done',
	delete_account: {
		label: 'Delete Account and Profile',
		text: `To delete your account and profile, send a message
to <b>{email}</b> with your request.`
	},
	disabled: 'Disabled | Disabled',
	description: 'Description | Descriptions',
	deleted: 'Deleted | Deleted',
	default: 'Default | Defaults',
	default_label: 'Default Label| Default Labels',
	derived_process: 'Derived Process | Derived Processes',
	discount: 'Discount | Discounts',
	down: 'down',
	developed_projects: 'Developed Project | Developed Projects',
	dashboard: 'Dashboard',
	deadline: 'Deadline | Deadlines',
	data: 'Data | Datas',
	date: {
		start_day: 'Start Day',
		end_day: 'End Day',
		label: 'Date | Dates',
		due_date: 'Due Date | Due Dates',
		paid_date: 'Paid Date | Paid Dates',
		by: 'Date By | Dates By',
		date_range: 'Date Range | Date Range',
		year: 'Year | Years',
		birth: 'Birth | Births',
		birth_day: 'Birthday | Birthdays',
		birthday: 'Birthday | Birthdays',
		today: 'today',
		last_week: '1 Week | {n} Weeks',
		last_month: '1 Month | {n} Months',
		last_year: '1 Year | {n} Years',
		one_week: '1 Week',
		one_month: '1 Month',
		one_year: '1 Year',
		month: {
			label: 'Month | Months',
			by_number: {
				short: {
					1: 'Jan',
					2: 'Feb',
					3: 'Mar',
					4: 'Abr',
					5: 'Maio',
					6: 'Jun',
					7: 'Jul',
					8: 'Ago',
					9: 'Set',
					10: 'Out',
					11: 'Nov',
					12: 'Dez',
				}
			}
		}
	},
	document_model: 'Document Model | Document Models',
	specific_period: 'Specific Period | Specific Period',
	enabled: 'Enabled | Enabled',
	extract: 'Extract | Extracts',
	exception: 'Exception | Exceptions',
	experience: 'experience | Experiences',
	external_link: {
		label: 'External Link | External Links',
		message: {
			confirm_delete_link: 'This will permanently delete the url. Continue?',
			explain_in_process: `The external user registered by the link below
								will automatically have their profiles
								linked to this process.<br/>
								Admin user linked to
								this process will receive a warning each
								time a new profile is registered through
								one of those link. |
								External users registered by the links below
								will automatically have their profiles
								linked to this process.<br/>
								Admin users linked to
								this process will receive a warning each
								time a new profile is registered through
								 one of these links.`,
			explain_in_profile: `
								External links can be shared with others to register
								profiles directly in your account. <br>
								Whenever someone creates a new profile on your account, you will be notified. <br>
								Share the link on social networks, on your
								corporate website, by email or wherever you want. <br> <br>
								<strong>
								<a href="/#/admin/profile_types">
								<u>
								To define and keep privacy and security policies up to date
								terms of use, access the profile type settings
								corresponding. <a href="/admin/profile_types/"> Access here <a/>
								</u>
								<a> </strong>`,
			change_terms_in_profile_settings: `To define and update the Terms and Policies of use
				that must be accepted by the profile owners, access the
				specific profile type settings.
				<br> <br> As the registration is not being updated by
				profile owner himself, it is indicated to keep evidence that the same
				agreed with the expressed terms. When you indicate in the registration of a profile of another
				The person who accepts the terms is actually stating that the profile owner agrees. <br> <br>
				Check and respect the legislation in force in your country regarding data protection.
				If you are unsure about this legislation, seek proper legal advice before registering
				third party profiles.`
		}
	},
	experience_years: 'No Experience | {years} year | {years} years',
	email: 'Email | Emails',
	education: 'Education | Educations',
	expense: 'Expense | Expenses',
	end: 'End | Ends',
	end_date: 'End Date| End Date',
	error: {
		label: 'Error',
		file_too_big: 'Maximum allowed size is 1mb',
		sending_data: 'Error sending data',
		generic: 'An error has occurred. Cod. {code}',
		item_is_required: '{item}: Is required',
		comment_something: 'Comment something',
		user_not_confirmed_email_sent: `Email not confirmed. A confirmation
      message was sent again. Please, confirm that. Please access the link in the message.`
	},
	profile_bank: 'Profile Bank | Profile Banks',
	profile_rules: {
		allow_use_profile_any_process: 'Allow use profile any process',
		expire_profile: 'Expire Profile 2',
		not_expire: 'Not expire',
		only_on_process: 'Only One Process',
		after_end_processes: 'After registred process',
		after_n_months: 'After 1 Month | After {n} Months',
		allow_internal_share: 'Allow internal share',
		only_internal_information:
		{
			label: 'For internal use only',
			explanation: 'Visible only to administrative users of the account.'
		},
		allow_external_share: 'Allow external share',
		is_privacy_policy: 'Is Privacy Policy',
		contact: {
			registred_process: 'Allows contact to registred processes',
			other_process: 'Allows contact to other processes'
		},
		accept_by_other_user: `Acceptance of the terms and policies
													and their conditions when registration is not made by the
													 profile owner is subject to further proof
													 of acceptance. <br>
													 <b>
													 Tip: Attach files as proof or request
													 a direct register
													 </b>`
	},
	from: 'From',
	free_support_and_training: 'Free support and training',
	file_attachment: 'File Attachment',
	feature: 'Feature | Features',
	fixed_cost: 'Fixed Cost | Fixed Costs',
	first_name: 'First Name | First Names',
	flow: 'Flow | Flows',
	flow_process: 'Process Flow | Processes Flows',
	file: 'File | Files',
	field: 'Fild | Filds',
	filter: 'Filter | Filters',
	filter_by_user: 'Filter by User | Filter by Users',
	financial: {
		balance: 'Balance | Balance',
		paid: 'Paid | Paid',
		opened: 'Opened | Opened',
		received: 'Received | Received',
		financial_process: 'Financial Process | Financial Processes',
		income_registration: 'Income Registration | Incomes Registrations',
		income: 'Income | Incomes',
		expense_registration: 'Expense Registration| Expenses Registrations',
		expense: 'Expense| Expenses',
		account_receivable: 'Account Receivable| Account Receivable',
		financial_recovery: 'Financial Recovery | Financial Recoveries',
		account: 'Account | Accounts',
		account_plan: 'Account Plan | Accounts Plans',
		all_accounts: 'All Accounts',
		receipt_method: 'Receipt Method | Receipt Methods',
		receipt: 'Receipt | Receipt',
		payment: 'Payment | Payment',
		cost_center: 'Cost Center | Cost Center',
		default_cost_center: 'Default Cost Center| Default Cost Centers',
		default_currency: 'Default Currency | Default Currency',
		bank_account: 'Bank Account | Bank Accounts',
		financial_account: 'Financial Account | Financial Accounts',
		default_account: 'Default Account| Default Accounts',
		label: 'Financial',
		financial_record: 'Financial Record | Financial Records',
		installment: 'Installment | Installments',
		payment_method: 'Payment Method | Payment Methods',
		price: 'Price | Prices',
		rate: 'Rate | Rates',
		discount: 'Discount | Discounts',
		interest: 'Interest | Interests',
		additional_fee: 'Additional fee | Additional fees',
		additional: 'Additional | Additional',
		percentage_discount: 'Percentage Discount',
		fixed_discount: 'Fixed Discount',
		allow_installment: 'Allow Installment',
		receive_single_installment: 'Receive single installment',
		type_interest: 'Type Interest',
		compound_interest: 'Compound Interest',
		simple_interest: 'Simple Interest',
		add_to_total: 'Add to Total',
		totals_by_cost_center: 'Totals By Cost Center',
		grouped_by_cost_center: 'Grouped By Cost Center',
		incomes_by_cost_center: 'Incomes by Cost Center',
		expenses_by_cost_center: 'Expenses by Cost Center',
		message: {
			cant_edit_paid_records: `Paid records can only be deleted. Deleting a this record will delete all your financial records as well.`,
			cant_edit_received_records: `Received records can only be deleted. Deleting a this record will delete all your financial records as well. `,
			general_discount_all_payments: 'General discount to all payments',
			specific_discount_by_installments: 'Specific discount by number of installments'
		}
	},
	gender: 'Gender | Genders',
	general_registration: 'General Registration | General Registrations',
	home: 'Home | Homes',
	height: 'Height | Heights',
	help_center: 'Help Center | Help Centers',
	input: 'Input | Inputs',
	in_progress: 'In Progress',
	id: 'Id | Ids',
	import_product: 'Import Product | Import Products',
	import_selected_profiles: 'Import Selected Profiles | Import Selected Profile',
	incomplete: 'Incomplete | Incompletes',
	institution: 'Institution | Institutions',
	instalment: 'Instalment | Instalments',
	item: 'Item | Itens',
	interview: 'Interview | Interviews',
	income: 'Income | Incomes',
	logout: 'Log Out',
	logo: 'Logo | Logos',
	link: 'Link | Links',
	link_to_register_form: 'Link to Register Form | Link to Register Forms',
	link_to_register: 'Link to Register Profile | Links to Register Profiles',
	linked_user: 'Linked User | Linked Users',
	linked_user_status: 'Linked User and Status | Linked Users and Status',
	last_update: 'Last Update | Last Updates',
	linked_process: 'Linked Process | Linked Processes',
	lebel: 'Lebel | Labels',
	level: 'Level | Levels',
	lag_level: {
		ALL: {
			label: 'All levels',
			desc: ''
		},
		1: {
			label: 'Native',
			desc: 'Mother Tongue'
		}
		,
		2: {
			label: 'Fluent',
			desc: 'High level of proficiency'
		},
		3: {
			label: 'Average',
			desc: 'Basic communication'
		},
		4: {
			label: 'Low',
			desc: 'Understands and communicates with difficulty'
		}
	},
	education_level: {
		1: {
			label: 'Secondary'
		}
		,
		2: {
			label: 'Bachelor’s'
		},
		3: {
			label: 'Master'
		},
		4: {
			label: 'Doctorate Degree'
		}
	},
	list: 'List | Lists',
	login: {
		label: 'Login',
		forgot_password: 'Forgot your password?',
		change_password: 'Change password',
		request_change_password: 'Request Change Password',
		login_error: 'Sorry, incorrect access data...',
		change_pw_error: 'Error updating password.',
		request_pw_msn: 'Request received successfully.<br> An email has been sent to {email} with a link to update password.',
		password_updated: 'Password Updated.',
		repeat_password: 'Repeat Password'
	},
	language_set: {
		label: 'Language | Languages',
		portuguese: 'Portuguese',
		portuguese_br: 'Portuguese BR',
		english: 'English',
		english_us: 'English',
		spanish: 'Spanish'
	},
	link_generate: {
		short_explanation: {
			what_is: 'The candidate will can create a user and register his profile.',
			process_bind: 'The processes will be binded with the profile\'s account.',
			user_bind: 'The users will be binded with the profile\'s account. When the profile is updated or the user sent a message, the users will receive messages',
		}
	},
	language: {
		label: 'Language | Languages',
		portuguese: 'Portuguese',
		portuguese_br: 'Portuguese BR',
		english: 'English',
		english_us: 'English - US',
		spanish: 'Spanish'
	},
	main: 'Main | Main',
	model: 'Model | Model',
	menu: 'Menu | Menus',
	min: 'Min | Min',
	max: 'Max | Max',
	main_user: 'Main User| Main Users',
	main_process: 'Main Process | Main Processes',
	main_profiles: 'Main Process | Main Profiles',
	media: 'Media | Medias',
	my_account: 'My Account | My Accounts',
	min_stock: 'Max Stock | Max Stock',
	max_stock: 'Min Stock | Min Stock',
	my_user: 'My User | My Users',
	my_profile: 'My Profile | My Profiles',
	method: 'Method |Methods',
	module: 'Module |Modules',
	municipal_code: 'Municipal Code | Municipal Codes',
	message: {
		label: 'Message | Messages',
		new_skill_in_select: 'To create a new skill, just type and select it.',
		visible_to_profile_owner: 'Visible in the profile owner area. Basic process data only.',
		agree_update_terms: 'I understand and assume responsibility for the terms of use and privacy policies applied to the profile registration.',
		agree_above_terms: 'I understand and agree with the guidelines above.',
		we_are_preparing_your_account: 'We are preparing your account...',
		account_confirmed: 'Thanks, Account confirmed!',
		compare_reatings_click: 'First, pick up the profiles you want to compare.',
		open_windows: 'Open Windows',
		page_not_found: 'The page you requested could not be found.',
		there_id_no_selected_profile: 'Ainda não foram selecionados perfis',
		when_you_receive_payment: 'When you receive a payment',
		when_you_make_payment: 'When you make a payment',
		need_change_plan: 'It is necessary to change the plan. <ins>Change Plan</ins>',
		confirm_change_account_plan: 'When you change your plan, your plan value will be adjusted and an email will be sent within 48 hours to change your billing details, if outside the initial free period.',
		change_account_plan_confirmed: 'Plan change CONFIRMED',
		change_account_plan_canceled: 'Plan change CANCELED',
		choose_process_in_dashboard: 'No data or no process selected to this Dashboard.<br> Choose the processes you want to see here.',
		average_from_x_records: 'Avarage from {n} record | Avarage from {n} records',
		total_x_ratings_submitted: 'Total {n} Ratings Submitted | Total {n} Ratings Submitted',
		chart_one_year_by_process_type: 'Up to one year period, considering archived processes',
		started_x_closed_process: 'Started X Closed Processes',
		active_processes_by_status: 'Active processes by status (not archived)',
		actived_processes: 'Actived processes | Actived processes',
		actived: 'Actived | Actived',
		delete_completed: 'Delete completed',
		remove_completed: 'Remove completed',
		delete_canceled: 'Delete canceled',
		remove_canceled: 'Remove canceled',
		archive_completed: 'Archive completed',
		archive_canceled: 'Archive canceled',
		unarchive_completed: 'Unarchive completed',
		unarchive_canceled: 'Unarchive canceled',
		equal_or_greater: 'Equal or greater',
		terms_and_policies: 'Terms and Policies',
		privacy_policies: 'Privacy policies',
		terms_of_use: 'Terms of use',
		account_registered: 'Account registered',
		confimation_sent: `<p class="h4">
						  A message with a confirmation
						  link has been sent to {email}.
						  </p>
						  <p class="h4">
						  Please check your email.
						  </p>`,
		confimation_sent_simple: `
						  A message with a confirmation
						  link has been sent to {email}.`,
		mensage_deleted: 'Mensage Deleted.',
		mensage_sent: 'Mensage Sent.',
		mensage_sent_thanks: 'Mensage Sent. Tanks!',
		no_rating_registred: 'No rating registered',
		will_response_soon: `We'll response soon.`,
		are_you_sure: 'Are you sure?',
		confirm_delete: 'Confirm Delete?',
		confirm_archive: 'Confirm Archive?',
		confirm_unarchive: 'Confirm Unarchive?',
		from_your_selected_skills: 'from your selected Skills',
		filter_by_language: 'Filter by language | Filter by languages',
		filter_by_skill: 'Filter by Skill | Filter by skills',
		slogan: 'Process and Profile Management',
		show_edit_mode: 'Show Edit Mode',
		hide_edit_mode: 'Hide Edit Mode',
		hide_sensitive_data: 'Hide Sensitive Data',
		repeat_password: 'Reapeat Password',
		hello: 'hello!',
		coded_by: 'Developed by',
		updated_by: 'Updated by',
		updated: 'Updated | Updated',
		created_by: 'Created by',
		month_free: '{n} Day Free | {n}º Days Free',
		no_records: 'No Records',
		no_profile_added: 'No profile added',
		name_or_code: 'Name or Code',
		number_job_openings: 'Number of job openings',
		number_profile_to_select: 'Number of {label} to select',
		profile_to_select: '{label} to select',
		data_visible_to_candidate: 'Data visible to the candidate.',
		avaliation_topic_x_weight: 'Avaliation Topics X Weight',
		send_owner_link: 'Send to profile owner',
		send_owner_link_txt: `The profile owner will be able to update your data, access
		basic informations his process, attach files and send messages.`,
		select_profile_with_ratings: 'Select a profile with ratings',
		resquest_owner_update: 'Request owner update',
		copy_tags: `Copie (Ctrl + C) e cole (Ctrl + V) as TAGs no editor
					de texto para exibir o conteúdo correspondente quando
					gerar o documento.`,
		owner_restriction: `Apenas o autor e usuários com o quais houve
							compartilhamento.<br>
							A menos que haja limitação do perfil do usuário:`,
		allow_as_phisical_person: 'Allow as Phisical Person',
		allow_as_company: 'Allow as Company',
		from_selected_skills: 'from your selected {label}',
		confirm_leave_form: 'Confirm to leave this form? Unsaved data will be lost.',
		confirm_remove_profile_in_process: 'Confirm remove profile from this process | Confirm remove profiles from this process'
	},
	name: 'Name | Names',
	not_archived: 'not archived | not archived',
	not_confirmed: 'Not Confirmed | Not Confirmed',
	not_rated: 'Not Rated | Not Rated',
	not_selected: 'Not Selected | Not Selected',
	name_singular: 'Name Singular| Names Singular',
	name_plural: 'Name Plural| Names Plural',
	new_product: 'New Product | New Products',
	new: 'New | News',
	new_type: 'New Type| News Types',
	number: 'Number | Numbers',
	next: 'Next | Next',
	new_reating: 'New Rating | New Ratings',
	no_status_registred: 'No Status Registred | No Status Registred',
	new_account: {
		create_new_account: 'Create New Account',
		create_your_account: 'Create Your Account',
		profile_management: 'Profile management',
		process_management: 'Process management',
		financial_management: 'Financial Management',
		text: {
			profile_features: `- Register Profiles;<br>
								- Link to register Profiles;<br>
								- Profiles owner Area;<br>
								- Send quick message to profiles owners;<br>
								`,
			process_features: ` - Tasks; <br> 
                - Recruiting / Selective Process;<br>
								- Hiring Process;<br>
								- Interview;<br>
								- Sales;<br>
								- Purchase;<br>
								- Projects;<br>
								- Quotation Process;<br>
								- Custom Processes;<br>
								- Others...<br>
								`,
			financial_features: `- Register Incomes:<br>
								- Register Expenses;<br>
								- Financial Reports;<br>`
		}
	},
	only_open_task: 'Only open task | Only open tasks',
	official_identification: 'Official Identification | Official Identifications',
	observation: 'Observation | Observations',
	ok: 'Ok',
	online_system: 'Online System | Online Systems',
	operating_area: {
		label: 'Operating Area',
		culture: 'Culture',
		human_resouces: 'Human Resouces',
		provide_services: 'Provide Services',
		product_sales: 'Product Sales',
		products_and_services: 'Products and Services',
		financial: 'Financial',
		education: 'Education',
		ti: 'TI',
		marketing: 'Marketing',
		health: 'Health',
		others: 'Others',
	},
	opened: 'Opened | Opened',
	open_task: 'Open Task | Open Tasks',
	overview: 'Overview | Overviews',
	origin_process: 'Origin Process | Origin Processes',
	per_user_per_month: 'per user per month',
	pending: 'Pending',
	process: 'Process | Processes',
	process_and_profile_configurator: 'Process and profile configurator',
	process_settings: 'Process Settings | Processes Settings',
	process_permissions: 'Process Permission | Processes Permissions',
	process_management: 'Process Management',
	perishable: 'Perishable | Perishable',
	process_module: {
		label: 'Process Module| Processes Modules',
		process: 'Process | Processes',
		messagem: {}
	},
	process_id: 'Process Id | Processes Ids',
	process_type: 'Process Type | Processes Types',
	process_resume: 'Process Resume | Process Resumes',
	profile: 'Profile | Profiles',
	profile_status: {
		label: 'Profile Status | Profiles Status',
		desc: 'Easily track and update the status of all profiles that participate in a process.',
	},
	profile_and_curriculum: 'Profile & Resume| Profiles & Resumes',
	profile_group: 'Profiles Group | Profiles Groups',
	profile_removed: 'Profile Removed | Profiles Removed',
	profile_settings: 'Profile Settings | Profiles Settings',
	profile_permissions: 'Profile Permission | Profiles Permissions',
	profile_n: '{n} Profile | {n} Profiles',
	profile_type: 'Profile Type | Profiles Types',
	profile_user: 'Profile User | Profiles Users',
	permissions: {
		label: 'Permission | Permissions',
		allow_rating_profile: 'Allow rating profile | Allow rating profiles',
		profile_user_permission: 'Profile user permission | Profile user permissions',
		show_in_his_process_list: 'Show in his process list | Show in his process lists',
		show_basic_data: 'Show Basic Data | Show Basic Data',
		show_product: 'Show Product | Show Products',
		show_product_value: 'Show Product Value | Show Products Values',
		show_income: 'Show Income | Show Incomes',
		show_expense: 'Show Expense | Show Expenses',
		show_file: 'Show File | Show Files',
		show_process_flow: 'Show Process Flow | Show Processes Flow',
		show_profile_list: 'Show Profile List | Show Profiles Lists',
		show_profile_cv: 'Show Profile CV | Show Profiles CVs',
		show_comment: 'Show Comment | Show Comments',
		add_file: 'Add File | Add Files',
		in_selective_process: 'in selective process | in selective processes'
	},
	product: 'Product | Products',
	product_destination: 'Product Destination | Product Destinations',
	product_origin: 'Product Origin | Product Origin',
	product_updated: 'Product Updated | Products Updated',
	product_registred: 'Product Registred| Products Registred',
	project: 'Project | Projects',
	position: 'Position | Positions',
	previous: 'Previous | Previous',
	password: 'Password | Passwords',
	password_repeat: 'Repeat Password | Repeat Passwords',
	payment: 'Payment | Payments',
	point: 'Point | Points',
	profile_id: 'Profile ID | Profile IDs',
	professional_identification: 'Professional Identification | Professional Identifications',
	plan: {
		label: 'Plan | Plans',
		for_custom: 'For custom plans, please contact {email}',
		use_your_domain: {
			label: 'Your domain',
			text: 'Your domain will be used to access your account.'
		},
		use_your_email: {
			label: 'Your email',
			text: 'Use your corporate email address when the system sends messages from your account.'
		},
		your_logo: {
			label: 'Your Logo',
			text: 'Use your corporate email address when the system sends messages from your account.'
		},
		custom_theme: {
			label: 'Your colors and themes',
			text: 'Use your corporate email address when the system sends messages from your account.'
		},
		custom_features: {
			label: 'Custom Features',
			text: 'Use your corporate email address when the system sends messages from your account.'
		}
	},
	quotation: 'Quotation | Quotations',
	quotation_and_purchase: 'Quotation/Pruchase',
	ranking: 'Ranking | Rankings',
	resend_confimation_email: 'Resend confirmation email.',
	result: 'Result | Results',
	registred_reating: 'Registred Rating | Registred Ratings',
	reatings: 'Rating | Ratings',
	registred_date: 'Registred Date | Registred Date',
	ratting_submitted: 'Ratting Submitted | Rattings Submitted',
	ratting_deleted: 'Ratting Deleted | Rattings Deleted',
	required: 'Required | Required',
	recent_activity: 'Recent Activity | Recent Activities',
	responsible: 'Responsible | Responsibles',
	responsible_user: 'Responsible User | Responsible Users',
	raking_position: 'Raking Position | Raking Positions',
	rating_record: 'Rating Records',
	requirement: 'Requirement | Requirements',
	role: 'Role | Roles',
	seved: 'Saved | Seved',
	recruitment: 'Recruitment | Recruitments',
	referral: {
		label: 'Referral | Referras',
		have: 'Have Referral | Has Referras',
		label_email: 'Referral Email| Referrals Emails',
		text_register: 'E-mail of the person who introduced you to the system'
	},
	resume: 'Resume | Resumes',
	record: 'Record | Records',
	rating: 'Rating | Ratings',
	subject: 'Subject | Subjects',
	setting: 'Setting | Settings',
	stock_control: 'Stock Control | Stock Controls',
	state_code: 'State Code | State Code',
	selected: 'Selected | Selected',
	start: 'Start | Starts',
	started: 'Started | Started',
	start_date: 'Start Date| Starts Date',
	storage: 'Storage | Storage',
	shipping: 'Shipping | Shippings',
	specialization: 'Specialization | Specializations',
	summary: 'Introduction | Introductions',
	start_page: "Start Page",
	serial_number: 'Serial Number | Serial Numbers',
	selective_process: 'Selective Process | Selective Process',
	skill: 'Skill | Skills',
	skill_levels: {
		ALL: 'All | All',
		1: 'Beginner | Beginners',
		2: 'Intermediate | Intermediates',
		3: 'Professional | Professionals',
		4: 'Senior | Seniors',
		5: 'Expert | Experts'
	},
	stock: 'Stock | Stocks',
	service: 'Service | Services',
	selection_data: 'Selection Data | Selection Data',
	status: 'Status | Status',
	status_detail: 'Status Detail| Status Details',
	supplier: {
		label: 'Supplier | Suppliers',
		name: 'Supplier Name | Supplier Names',
		code: 'Supplier code | Supplier Codes',
		contact: 'Supplier Contact | Supplier Contacts'
	},
	to: 'to',
	to_sale: 'To Sale | To Sale',
	tag: 'Tag | Tag',
	title: 'Title | Tiltes',
	street: 'Street | Streets',
	weight: 'Weight | Weights',
	task: 'Task | Tasks',
	team_management: 'Team Management',
	term: 'Term | Terms',
	type: 'Type | Types',
	time: 'Time | Times',
	technology: 'Technology | Technologies',
	total: 'Total | Totals',
	total_by_status: 'Total by Status | Totals by Status',
	topic_point: 'Topic Point | Topics Points',
	topic: 'Topic| Topics',
	topic_type: {
		integer: 'Number',
		value: 'Money',
		decimal: 'Number Decimal',
		stars: 'Stars',
		boolean: 'Yes/No'
	},
	undone: 'Undone | Undone',
	url: 'Url | Urls',
	unlimited: 'Unlimited | Unlimited',
	updated: 'Updated | Updated',
	user: {
		label: 'User | Users',
		select: 'Select User | Select Users'
	},
	n_user: {
		label: '{n} User | {n} Users'
	},
	value: 'Value | Values',
	your_profile: 'Your Profile | Your Profiles',
	your_comment: 'Your Comment | Your Comments',
	your_message: 'Your Message | Your Messages',
	warning: 'Warning | Warnings',
	kanban: 'Card | Cards',
	site: {
		register: {
			title: 'Get Free Account',
			subtitle: 'Get your free account now and start using ProcessFlex.',
			btn_create_your_account: 'Get Free Account',
			registred: {
				title: 'Account registered',
				msn: "A message with a confirmation link has been sent to {email} from app@processflex.com. <br>If you can't find the message, check the spam folder.",
				check_email: 'Please check your email.',
				accept_terms: 'I accept the terms of use',
				accept_privacy_policy: 'I accept the privacy policy'
			}
		},
		home: {
			title: 'System for Process and Profile Management',
			subtitle: `
				Set statuses, assign responsibilities, create checklists,
			 	establish deadlines, and much more. All within a single, easy, and flexible system.
			`,
			features: {
				title: 'Features',
				subtitle: 'Discover some of the features that ProcessFlex offers:',
				process: {
					desc: `
						<p class="text-justify">
							Use pre-existing processes or create new types freely.
							Have control of your processes with a configurator and
							make adjustments to adapt each process type to your reality.
						</p>
						<p class="text-justify">
							Set status, who participates in them, receive files,
							send messages, assemble your team and more.
						</p>
					`
					},
					profile_and_cvs: {
					desc: `
					<p class="text-justify">
						Candidates, customers, suppliers, employees or whoever you need most.
						Create new profile types and adjust the settings as needed.
					</p>
					<p class="text-justify">
						Have specific links to the registration directly by the profile owner, either
						a candidate, customer, supplier or any other profile type.
					</p>
					`
					},
					custom_features: {
					desc: `
						<p class="text-justify">
							Do you have unique needs and can't find suitable solutions?
							Only you know what your company really needs.
						</p>
						<p class="text-justify">
							Get in touch and let's talk to find the best
							solutions in each case.
						</p>
					`
				}
			}
		},
		resumes: {
			company: {
				desc: `
					Create and manage your resume bank.
					Resumes added by your account will
					be exclusive and shareable with protected links.`
			},
			candidate: {
				desc: `
					Register now your resume quickly
					and easily and without cost.
					Share with links, PDF or print.`
			}
		},
		recruitment: {
			title: 'Recruitment and Curriculum',
			subtitle: `
			<p>
			Have full control of recruitment and management processes
			of your company's resume base.
			</p>
			<p>
				<ul class="text-left">
					<li>
						Recruitment management;
					</li>
					<li>
						Curriculum Bank;
					</li>
					<li>
						"Work with us" area;
					</li>
					<li>
						Other configurable processes and profiles;
					</li>
					<li>
						Financial control;
					</li>
				</ul>
			</p>
			`,
			features: {
				title: 'Recursos',
				subtitle: 'Conheça alguns dos recursos que o ProcessFlex oferece:',
				process: {
					desc: `
						<p class="text-justify">
							Use os processos pré-existentes ou crie novos tipos livremente. 
							Tenhas o controle dos teus processos com um configurador e 
							faças os ajustes para adequar cada tipo de processo à sua realidade.
						</p>
						<p class="text-justify"> 
							Defina status, quem participa deles, receba arquivos,
							envie mensagens, monte sua equipa e mais.
						</p>					
					`
				},
				profile_and_cvs: {
					desc: `
					<p class="text-justify">
						Canditatos, clientes, fornecedores, funcionários ou quem mais precisas,
						crie tipos de perfis novos e ajuste suas configurações como precisas.
					</p>
					<p class="text-justify">
						Tenha links específicos para o registo diretamente pelo dono do perfil, seja 
						um candidato, cliente, fornecedor ou qualquer outro tipo de perfil.
					</p>					
					`
				},
				custom_features: {
					desc: `
					<p class="text-justify">
						Possui necessidades únicas e não encontras soluções adequadas?
						Apenas tu sabes o que a sua empresa realmente precisa.
					</p>
					<p class="text-justify">
						Entre em contato e vamos conversar para encontrarmos as melhores
						soluções para o seu caso.
					</p>
					`
				}
			},
		},
		tasks: {
			desc: `
			<p>
			Facilitate the management of your tasks and your team. Record tasks and handle their management and control easily and simply.
			</p>
			<p>
					Keep all tasks in order. Control their status, designate responsibilities, outline activities that need completion, attach files, and much more.
			</p>
			<p>
					Conduct task searches effortlessly and intelligently to keep them organized and up-to-date. When tasks are completed, simply "archive" them for future reference or to generate reports on past activities.
			</p>
			`,
			list: `
			<lu>
					<li><strong>Easy and quick creation of new tasks;</strong></li>
					<li><strong>Smart filtering: Search for your tasks by title, period, status, etc;</strong></li>
					<li>Custom status creation: Create the statuses you want in the order you desire;</li>
					<li><strong>Kanban Board view:</strong> 
							Have columns with the statuses you defined and cards with each task. Drag to update status, edit tasks as you wish;</li>
					<li><strong>Todo-list:</strong> List everything that needs to be done for each task in one place and track what has been completed;</li>
					<li><strong>Task assignment:</strong> Define who is responsible for the task;</li>
					<li><strong>Attach files and images:</strong> Attach documents and images to have everything related to the task in one place;</li>
					<li><strong>Subtasks:</strong> From a main task, create other derived tasks;</li>
			</ul>`
		},
		quotation_and_purchase: {
			desc: `
			<p>
					Transform your procurement management with our Quotation and Purchasing system. 
					Streamline the process of requesting quotes, analyzing proposals, and closing 
					deals seamlessly. 
					</p>
					<p>
					Evaluate and compare the best suppliers, ensuring the optimal
					choice for your company. Moreover, maintain complete control over decisions by
					blocking purchase approvals until authorized by a designated user. 
					Enhance operational efficiency and make more strategic decisions for the
					growth of your business.
			</p>
			`,
			list: `
			<p><strong>Quotations and Purchases Record:</strong> Easily and quickly record your transactions;</p>
			<p><strong>Intelligent Filtering:</strong> Find your processes with ease;</p>
			<p><strong>Compare Suppliers:</strong> Define evaluation criteria and always choose the best option based on reviews;</p>
			<p><strong>Supplier Registration:</strong> Keep your supplier database up-to-date and accessible;</p>
			<p><strong>Attach Documents:</strong> Attach scanned documents;</p>
			<p><strong>Assignment of Responsibility:</strong> Define who is responsible for the processes;</p>		
			`
		},
	
		plans: {
			subtitle: 'Choose one of the plans or request a tailored solution.'
		},
		features: {
			title: 'Features',
			subtitle: `
			<p>Flexible and customizable features as you need.</p>
			<p>
			ProcessesFlex is a system for managing processes and profiles. 
			It can be a purchase, a project, a selection process, product development 
			or any other process that you need to have control over.<br>
			</p>
			<p>
			 Define which types of profiles are part of the process, the status,
			 whether there is financial movement, products, profile comparison 
			 (for selective or quotation processes, for example) and more. <br>
			 </p>
			 <p>
			 Have pre-configured processes and customize everything your way. <br>
			 </p>
			 <p>
			 If you have any questions, contact us and get all the support you need.
			 </p>
			`,
			processes: {
				title: 'Processes',
				subtitle: 'Create and Customize Process',
				pre_registred: {
					title: 'Pre-registered:',
					list: `
					<ul class="col-md-5">
						<li> Tasks; </li>
						<li> Recruitment; </li>
						<li> Purchasing; </li>
						<li> Sales; </li>
						<li> Projects; </li>
					</ul>
					<ul class="col-md-5">
						<li> Quotation; </li>
						<li> Meeting; </li>
						<li> Hiring; </li>
						<li> And More... </li>
					</ul>
				`
				},
				features: {
					title: 'Features',
					list: `
						<ul class="col-md-5">
							<li> Custom status; </li>
							<li> Linked tasks; </li>
							<li> Selection of profiles; </li>
							<li> Evaluation of profiles; </li>
							<li> Comparison of profiles; </li>
							<li> Attach files; </li>
							<li> Send message; </li>
						</ul>
						<ul class="col-md-5">
							<li> Products and services; </li>
							<li> Cost and revenue control; </li>
							<li> Attach files; </li>
							<li> Deadlines; </li>
							<li> Time line; </li>
							<li> Canban board; </li>
							<li>Assing team members;</li>
						</ul>
					`
				},
				new_types: {
					title: 'New  process types:',
					content: 'Unlimited creation new types of custom processes.'
				}
			},
			tasks: {
				title: 'ToDo',
				create_and_assing: {
					title: 'ToDo List',
					description: 'Create and assign activities for team members in processes'
				},
				all_your_tasks: {
					title: 'Your ToDo List',
					description: 'Have a list of the activities you need to do. Never forget what needs to be done.'
				},
				process_tasks_status: {
					title: 'ToDo Status filter',
					description: 'Filter the ToDo list inside a process by status.'
				}
			},
			profiles: {
				title: 'Profiles',
				subtitle: 'Customizable your profile bank',
				pre_registred: {
					title: 'Pre-registered:',
					list: `
					<ul>
							<li>Customers</li>
							<li>Supplier</li>
							<li>Candidates</li>
							<li>Employee</li>
						</ul>
						<ul>
							<li>Consultant</li>
							<li>Seller</li>
							<li>Carrier</li>
							<li>Others...</li>
					</ul>`
				},
				features: {
					title: 'Features',
					list: `
						<ul class="col-md-6">
							<li> CV creation; </li>
							<li> Searches for skills, languages, etc; </li>
							<li> Exclusive link for registration; </li>
							<li> Linked processes; </li>
							<li> Evaluation of profiles; </li>
							<li> Comparison of profiles; </li>
							<li> Send message; </li>
						</ul>
						<ul>
							<li> Attach files; </li>
							<li> Skills; </li>
							<li> Projects; </li>
							<li> Languages; </li>
							<li> Activities; </li>
							<li> Education; </li>
						</ul>
				`
				},
				new_types: {
					title: 'New types of profiles:',
					content: 'Unlimited creation new types of custom profiles.'
				}
			},
			financial: {
				title: 'Financial',
				subtitle: 'Process financial control',
				features: {
					title: 'Features',
					list: `
					<ul class="col-md-5">
						<li> Accounts payable; </li>
						<li> Accounts receivable; </li>
						<li> Cost Centers; </li>
						<li> Processes revenue; </li>
					</ul>
					<ul class="col-md-5">
						<li> Process expenses; </li>
						<li> Movement filters; </li>
						<li> Financial charts; </li>
						<li> Extract of movements; </li>
					</ul>
					`
				},
			}
		}
	},
	terms: `
		The use of the CllFlex System implies acceptance of these Legal Terms and Conditions by the user (from this point on, always referred to as the ‘User’). Likewise, the use of the Web, intended for people of the required legal age, implies that the User is fully qualified to act on his own behalf. The User must read this document carefully and be aware that CllFlex and the Legal Terms and Conditions described here may be subject to change.
		<br> <br>
		Definitions
		<br> <br>
		Legal Terms and Conditions: This document, as well as any addendum, attachment, notes, or changes that may be included, at any time while the Web remains valid and in operation, constitutes the legal terms and conditions regarding the relationship between the User and the Web.
		<br> <br>
		Documents: Professional documentation such as Curriculum Histories (resumes), electronic profiles, cover letters, photographs, videos, graphics, images, tables of content, texts, data, User comments, communications, publications, messages, articles and any other type similar content that can be embedded on the web and edited, created, changed, etc.
		<br> <br>
		Services: Specialized content and services related to professional documentation, including those that allow the creation of resumes, electronic profiles, cover letters, photographs, videos, graphics, images, content tables, texts, data, User comments, communications, publications , messages, articles, and any other similar content type that can be embedded on the web.
		<br> <br>
		Users: The person who is authorized to access the Site according to the available modes, both a visitor and a potential User of the Web or with prior registration on the Web and thus the person who accepts these Legal Terms and Conditions for use services offered by www.processflex.com.
		<br> <br>
		Web / Site: The place on the Internet where www.processflex.com offers its services, managed and marketed by the Web and / or its partners and business associates.
		<br> <br>

		Trademark
		<br> <br>
		The services available on the website www.processflex.com are offered by the Web, a registered trademark and managed entirely by (hereinafter referred to as the 'Company') operating in Spain at its headquarters located in and registered with the Commercial Registry de Barcelona (Barcelona Mercantile Registry: T 45832, F 48, S 8, H B500429, I / A 1) with the number B66969718.
		Through its website www.processflex.com, the Company offers its Users clear and precise information about the characteristics of the products and services sold, as well as the necessary details for contacting its headquarters in Spain.
		<br> <br>
		Description of services
		<br> <br>
		Www.processflex.com is a service platform that allows its Users to access specialized content and services (from this point on, referred to as 'the Services') related to professional documentation such as those that allow the creation of resumes, electronic profiles , cover letters, photographs, videos, graphics, images, tables of contents, texts, data, user comments, communications, publications, messages, articles and other similar types of content. All content and services available on the Web that were not incorporated as of the 'Last Updated' date at the beginning of these Legal Terms and Conditions will automatically be considered to be included in the Services as they form part of the Web.
		The purpose of the Web is to serve as a portal on the Internet on which Users can create their Documents, and for certain companies to have access to the purpose of recruitment, selection, professional interview, offering services, etc. Www.processflex.com does not evaluate, control, edit or monitor the Documents, and does not evaluate them or make selections from Documents or individuals. The Site is not involved in any transactions or exchanges of information between contractors and Users, so the Site has no control over the quality, truthfulness, reliability, sincerity, integrity or availability of the Documents, nor the ability of potential contractors to do so. offer career opportunities, or individuals completing job applications. Www.processflex.com will not make any representations or warranties of any kind about potential contractors or individuals.
		The information that becomes available through the Web, including any information regarding the creation, alteration and / or revision of Documents on the Site, will be governed by the Privacy Policy of www.processflex.com, which is available on the page www.processflex.com / privacy-policy (the 'Privacy Policy'). These Legal Terms and Conditions incorporate the terms set out in the Privacy Policy as necessary.
		<br> <br>
		When creating Documents using the Web Services, Users grant the storage consent offered by the Web, as well as the possibility to share them with contractors or third parties who have access to Users' electronic profiles in accordance with applicable regulations and with the Privacy Policy. In the event that the connection to the Site is produced through the services of a third party, Users agree that www.processflex.com may access and use the information from these services in the permitted manner, and store these credentials for their use.
		To access the Web, Users must have the necessary equipment, which includes all the tools necessary to establish an Internet connection (including computers or laptops, modems, tablets, other devices, etc.) on which the Site cannot be accessed. held in any way as responsible.
		Registration, usernames and passwords <br> <br>
		<br> <br>

		Users will need to register at www.processflex.com to access certain Services or Web sites. Regarding registration, the Site may refuse to assign a username (or email address) that is already in use by another person, which may result in the illegal use of someone else's account; that violates or may violate an amount of intellectual property or other types of rights; that is offensive or that the Site determines to be unacceptable for any reason in exercising its sole discretion.
		<br> <br>
		The assigned username and password are for personal use only and are prohibited from being used by others, including colleagues from the same organizations as the User, those who offer or receive services to or from the User, or affiliates. Users are responsible for maintaining the confidentiality of any passwords they may use to access the Web, and undertaking not to transfer, communicate or surrender their usernames or passwords, or to lend or otherwise transfer their rights to use or access to the Web to any third parties.
		<br> <br>
		The Site may monitor the use of usernames or passwords and may request that the User change them at its own discretion. In the event that a username or password does not meet the necessary security conditions, www.processflex.com can immediately request its change, or close the User's account.
		Users are entirely responsible for any interaction on the Web that occurs with respect to their own usernames or passwords, including but not limited to any possible transactions, and specifically any subject costs. Users agree to immediately communicate to the Web about any unauthorized use of their usernames or passwords, or any other security incident with respect to their accounts, or to the Web itself, and also to ensure that they end their usage sessions. on the web (if necessary) at the end of each session. The Site should not be responsible for any loss or damage that may occur in the failure of these responsibilities.
		<br> <br>
		The Site reserves the right to evaluate each User order before allowing the use of the Services offered and Users when entering into a contract with the Site accept this. The Site may, at its sole discretion:
		Monitor requests for use of the Services. <br> <br>
		Change, delete or reject any request,
		Communicate requests and any relevant circumstances to third parties when necessary to use the Services, in accordance with applicable regulations.
		<br> <br>

		Payment for Services <br> <br>
		In the event that Users contract the Services of www.processflex.com, either for single use or through a subscription, Users grant their consent that third parties may process and store their payment details in order to receive payment for the Services contracted with the Site, in accordance with the application rules and the Privacy Policy.
		The contracting of the Site Services will be made by paying the corresponding amount together with any fees or taxes resulting from the application. In the event that the collection of income is carried out by Public Authorities through www.processflex.com, Users grant their consent and agree to refund such amounts, if payment is necessary.
		Users can pay for the Web Services through frequent or recurring payments of the corresponding amount, which will be established at the end of the contract with the User. Users will receive the information corresponding to the payment terms in accordance with the Web and in accordance with any applicable regulations, including the procedure for finalizing payment for the Services.
		<br> <br>
		Occasional Payments
		<br> <br>
		Www.processflex.com offers the possibility to contract the Services for a definitive period, or through the Basic and Premium plans. When contracting a Premium plan, Users agree to pay the applicable amount, which will be processed at the time of registration and will include the use of the Premium plan during the agreement enrollment period (30 days / one year). Users will pay for the Services contracted during the registration period and until cancellation.
		The registration periods will be automatically renewed in periods of time identical to those initially contracted, unless the User or the Site cancel the registration before the end of the current registration period. To cancel the registration, Users can do it through their personal profile pages https://app.onlinecurriculo.com/editor/profile/ by following these simple steps https://www.processflex.com/cancelar- a-inscriaco or by sending an email to info@onlinecurriulo.com.
		Users must provide data for payment for the Services that are truthful, accurate and up to date. In the event that the payment information is not updated and the User has not communicated the new payment information, the Site will collect any amount due to the Services contracted using the payment method initially designated. Users will be responsible for paying any amounts due to the Site.
		Possible images, descriptions, or references to products or services on the Web do not automatically imply the guarantee, loyalty or obligation to sell or sell these items through the Site. Www.processflex.com reserves the right, with or without notice, to make changes to such images, descriptions or references, to limit the quantity available of any product or service, to clarify or introduce limits or conditions for serving any coupon from discount, promotional code both on coupons and other elements, or other promotions, to prohibit Users from carrying out certain transactions under these terms, and to reject the offer of products or Services to any user.
		The price and availability of any product or service on the Web are subject to variation and change from time to time without notice and in accordance with the specifications of the Web. Any refunds or changes to the User Services will be made in accordance with the policies of refunds and transfers from the Web. Users must pay any amounts that may have become subject to the Web Services, under the terms agreed upon when contracting the Services, including, if applicable, any associated costs (such as shipping and storage costs) ), and applicable fees and taxes.
		<br> <br>

		Payments and Registration
		<br> <br>
		If you purchase any of the services we offer for a fee, one-time or full subscription, you agree that the Company's suppliers may store your payment information. You also agree to pay the applicable fees for the products or services you have requested (including monthly or yearly subscription fees) on their expiration dates, in addition to any related fees, and to reimburse us for any charges and interest on the overdue amounts. .
		Non-payment can cause your subscription to be terminated. Depending on the origin of your transactions, the payment method used and the origin of the payment method, your transaction may be subject to fees applicable for currency conversion or price differences due to the exchange. Your transaction may be subject to a currency conversion carried out by your bank or your card issuer. The Company is not responsible for any conversion costs or surcharges imposed by your bank or your card issuer. The Company does not accept all payment methods, currencies or locations. If the payment method you use with us expires, such as a credit or debit card, and you do not edit your payment information or cancel your account or service, you authorize us to continue to charge you using that same method payment, and you will be responsible for unpaid amounts.
		All applicable fees are calculated taking into account the payment information you provide at the time of purchase. You agree that any product or service purchased by you is subject to these conditions and any additional conditions related to the product or service offered by us.
		Minimum Contract Periods and Cancellation Rights
		The user will have the right to revert through a means in which he / she can request the cancellation of the Services and the period of 14 days to download all Documents stored to date on the Web, ensuring the return of the amount paid during that period. In addition, the user can cancel the service at any time during the current subscription period to avoid being charged for subsequent amounts. To do this, it is necessary to contact customer service at the email address info@onlinecurriulo.com or also do it directly through the profile page https://app.onlinecurriculo.com/editor/profile/ by following these simple stepshttps: //www.processflex.com/cancelar-a-inscricao. If you cancel a subscription period of more than one month, you will receive a refund for the remaining months in your entire subscription period. The current month will be charged and the User will have access to the subscription for the rest of that month. Partial months will not be refunded. Surcharges for registration periods will not be refunded, regardless of the length of the registration period.
		You agree that the Services will begin as soon as we send you an email confirming your subscription.
		General Conditions of Use

		<br> <br>
		The Site reserves the right to make changes and / or improvements at any time to the information contained on the Site or to the Site's settings at any time and without prior notice, which will be subject to the conditions set out in these Legal Terms and Conditions.
		<br> <br>
		In particular, it reserves the right to unilaterally change, without prior notice, the presentation, configuration and content of the Site, and the Services offered, as well as its operating rules and these Legal Terms and Conditions, always acting in accordance with the implementing legislation, and provided there is sufficient cause for it.
		<br> <br>
		In the event that there are changes, they would be communicated through the Site itself or according to the most effective means determined for the general knowledge of Users, and would be carried out to improve and update the operation.
		<br> <br>
		Any changes will be made immediately after the date of their publication on the website.
		<br> <br>
		The User agrees to use the Web correctly in accordance with the law and the legal notice, morals and public order present. The User will respond to the Site or to third parties for any damages that may be caused as a result of the breach of such obligation.
		<br> <br>
		Access, navigation and use of the Site is the responsibility of the User and he / she promises to use the contents diligently, correctly and in accordance with the law, as well as to faithfully respect any additional instructions offered by www.processflex.com or the staff the Web regarding the use of the Site and its contents. The User individually undertakes to avoid doing the following, but not only limited to the following:
		<br> <br>
		Use the content for purposes or actions contrary to the law, morals and generally accepted good manners, or public order. To this end, the Site reserves the right to prevent or prohibit access to any Internet User who introduces any content contrary to the Web or moral regulations to this Site, also reserving the right to take all legal measures that may correspond to avoid this type of conduct.
		<br> <br>
		Reproduce, copy, distribute or allow public access through any form of public communication; Change, change, modify or adapt the contents, unless authorized by the holder of the corresponding or legally permitted rights.
		<br> <br>
		Use content and, in particular, information of any kind obtained through the Web or its services to send advertising, communications for the purpose of direct sale or use it for any other type of commercial, promotional or messaging purpose (including any kind of 'malicious email', 'spam', 'chain', 'pyramid scheme' or similar), as well as commercialize or publish such information in any other way.
		<br> <br>

		Perform any act contrary to the rules that regulate the protection of personal data, the market and consumers, intellectual property, tax rules, which regulate the protection of honor, privacy, and the image and reputation of people or entities.
		<br> <br>
		Carry out any act of defamation, abuse or aggression, harassment, threat and / or fraud of any kind; as well as any act or activity that is considered or may be considered obscene, indecent, pornographic or related to pornography, or in any other way offensive.
		<br> <br>
		Perform any activity that may initiate civil or criminal liability, which encourages behavior punishable by law, or encourages or promotes illegal activities such as ‘hacking’, ‘cracking’ or ‘phreaking’.
		<br> <br>
		Introduce by any means elements such as viruses, malware, Trojans, 'Easter eggs', 'time bombs', spyware, or other software, codes or files that may be malicious, dangerous or invasive, or that may cause damage or damage. malicious use of Site operations, or monitor or control the use of any type of hardware, software or equipment.
		<br> <br>
		Use any robot, spider, search or data collection application on the Web, or install or use any automatic or manual device to collect, index, extract, do 'data mining' or otherwise collect or store the Web content, or reproduce or circumvent the navigation structure or presentation of the Web without prior consent from www.processflex.com.
		<br> <br>

		Use of the Web for purposes harmful to www.processflex.com, your property or your interests, or third parties is expressly prohibited, or use in any way that overloads, damages or makes networks, servers and other types of hardware, or products and applications (Software), the Site or unusable third parties.
		<br> <br>
		Users and, in general, anyone who accesses the Web through any channel, must refuse to obtain, or attempt to obtain any type of material accessible through the Web itself, or the services offered by the Web, through the use of means or procedures other than those available for such purposes.
		<br> <br>
		Responsibilities and Obligations
		<br> <br>
		The information offered and managed by the User is confidential and is subject to professional secrecy. The Site will treat the information of its Users in accordance with the rules of protection of personal data in force in Portugal and in the European Union, in particular Directive 95/46 / EC of the European Parliament and of the European Council, of 24 October 1995 on the protection of individuals with respect to the processing of personal data and on the free movement of such data and Regulation (EU) 2016/679 of the European Parliament and the European Council of 27 April 2016 on the protection of individuals with respect processing of personal data and the free movement of such data, repealing Directive 95/46 / EC.
		<br> <br>
		The Site guarantees to apply the appropriate security measures, adapted to the current regulations, designed to protect the confidentiality, security, integrity, and truthfulness of the information offered on this Site and will not assume any responsibility for any tangible or intangible damages, losses or losses resulting from the fraudulent use of the contents of the Site, or your own use or access to the Site, including any connections that may have been made through that site or the misuse of passwords or identifiers used to access the contents of the Site.
		<br> <br>
		After the end of the legal relationship established with the User, the Web is fully committed to preventing access to any data and information in its possession. The preservation of any data or information that is accessed by virtue of the services offered on the Web after the end of such services is expressly prohibited, regardless of the duty of conservation required by the applicable legal provisions.
		<br> <br>
		The Site guarantees to maintain all necessary operating conditions, updates, improvements, availability and security of the Web, as well as the conditions necessary to resolve any type of incident or query arising from the Services, and those that may be necessary to ensure the integrity of the necessary authentication and identification mechanisms.
		<br> <br>

		The Web and the Services performed through it, must be used exclusively as a tool for storing, consulting and managing the Services offered, with the Site becoming exempt from any responsibility regarding the misuse of the platform or for purposes contrary to those mentioned.
		<br> <br>
		The Site will not be responsible for the veracity or legality of any Documents stored by Users, nor for their use through the Web. The Site does not guarantee the quality or suitability of the files sent, consulted or stored which will be in any way the User's responsibility, and you should not be liable for direct, indirect, consequential damages or incidents of un attributable uses.
		<br> <br>
		The Site is not responsible for damages of any kind that may result from technical failures or the availability of the Site. In particular, www.processflex.com is not responsible for or guarantees that access to this Site will be uninterrupted or error-free. In no event will the Site be liable for losses, damages or losses of any kind resulting from accessing and using the Site, including, but not limited to, those caused to computer systems or those caused by the introduction of a virus.
		<br> <br>
		In this sense, the Web should not be legally responsible in any way for (a) interruptions in its commercial activities; (b) delays or interruptions in accessing the Web; (c) delivery failures, erroneous deliveries, corruptions, destruction or data changes; (d) damage caused to the computational equipment of Users or third parties during the provision of the Web service and (e) any other incidents that are beyond the Site's reasonable control. The Site will not be responsible for damages or losses caused by the decisions made and based on the information disclosed by this means or for any possible inaccuracies, omissions or errors contained therein. The Web is not responsible for damages and losses of any nature that may be derived from the unauthorized knowledge of third parties to the User's data and their use of the Site.
		<br> <br>
		Customer service
		<br> <br>
		Www.processflex.com has a User Support Service to guarantee the Services of the Site and to address possible incidents that may be caused, which can be reached through the email address info@onlinecurriulo.com.
		<br> <br>

		Links Policy
		<br> <br>
		The Site is not responsible in any way for the contents of sites on which they may have been mentioned in links on the Site. Similarly, the Web cannot be held responsible for the results obtained through these links or for the consequences derived from Users' access to them.
		<br> <br>
		The Site will only be responsible for the content and Services offered on the Sites mentioned in links on www.processflex.com to the extent that the Web has real knowledge of its illegality.
		<br> <br>
		In the event that a User may suspect a possible breach of the confidentiality conditions established on the Web, the User should contact the Web as soon as possible to minimize the possible negative effects that may result from such a situation. The Site should not be responsible for any loss or damage that may result from the event that such suspicions are not communicated in the manner indicated.
		<br> <br>
		Intellectual and Industrial Property
		<br> <br>
		The acceptance of these Legal Terms and Conditions by the User implies a license to use the Web tools, which will be exclusive or non-transferable, and which will allow the use and access to the Services offered by www.processflex.com anywhere in the world .
		<br> <br>
		Similarly, the entire Site, that is, the elements it contains (texts, images, trademarks, logos, audio files, software files, color combinations, etc.), as well as the structure, selection and the order of its Content is protected by the rules of Intellectual and Industrial Property in force in Spain and in countries where it is used, and cannot be explored, reproduced, distributed, altered, publicly transferred, transferred, transformed or disclosed in any other way not expressly authorized.
		<br> <br>
		Access to the Site does not grant Users any right or ownership over the intellectual and / or industrial property rights in the content it contains.
		<br> <br>
		Texts and graphic elements (design, logos, source code and the like) as well as content, images, trademarks, logos, etc. appearing on these pages, as well as their presentation and assembly, are the exclusive property of the Site, which holds all intellectual and industrial property rights thereon, including the software. Access to this material does not in any way imply the granting of a license for its reproduction and / or distribution, which in no case is permitted without the prior consent of the Web, even if the origin of it is detailed. The Site reserves the right to take any legal actions that may correspond to it in accordance with the applicable regulations against Users who violate or otherwise infringe the intellectual and industrial property rights derived from the Web.
		<br> <br>

		Possession of Information
		<br> <br>
		The User is the sole owner of the Documents that he / she incorporates, edits, modifies, manages or stores on the Site, therefore access to it by third parties other than the User will be carried out under the User's exclusive supervision and responsibility. In all cases, the User acknowledges the legality of all information used or disclosed on the Web, expressly exempting www.processflex.com, the Company, or its service providers, or business partners from any liability resulting from possible illegality of such information, and the infringement of the rights of third parties.
		<br> <br>
		The User can at any time download the Documents from the Web according to the functionalities of the Site, and will have a right of reversion as a means in which he can request the cancellation of the service and the download, for 14 days, of all the Documents stored to date on the Web, ensuring the elimination of all information as soon as the service is reversed.
		<br> <br>
		Cookies
		<br> <br>
		To obtain statistics on the number of visitors to the Web, CllFlex will make use of non-identifiable information related to visitors.
		The use of the Web may generate 'cookies', understood as fragments of information stored on the hard disk of the User's computer, which can be used to improve the operation of the Site in future visits and offer a better service to the User. The User has the possibility to reject the use of cookies on his computer. He / She can do this by adjusting your browser settings.
		<br> <br>
		Jurisdiction and Applicable Law
		<br> <br>
		These Legal Terms and Conditions will be governed, interpreted and executed in accordance with Portuguese regulations, waiving the User's own jurisdiction and submitting to the jurisdiction and location of the Courts and Courts of Lisbon (Portugal), despite any legal provision to the contrary.
		<br> <br>
		When using the Services from different locations, Users assume such use at their own risk and risk. Users must comply with regulations set forth in the locations where they are located and where they access the Services as applicable.
		<br> <br>

		Validity Terms
		<br> <br>
		These Legal Terms and Conditions will apply indefinitely until the Site determines its termination. The web may, at its discretion, terminate access to or use of the Site in accordance with applicable regulations, including the situation where Users may have violated or acted inconsistently with these Legal Terms and Conditions. Following the end of the Web, the User's rights will immediately cease, the Site being able to disable the assigned usernames and passwords, or delete them, along with any information and / or associated documentation and in accordance with the regulations of the application.
		<br> <br>
		Cllflex together with any brands, entities and associated organizations will not assume any responsibility for the termination of the use of the Site and / or the Services in addition to the economic costs that may arise with the contracting of the Services, in accordance with the terms of the cancellation and refund policies of the Site.
		<br> <br>
		Dispute Resolution
		<br> <br>
		Before initiating any procedure or intermediation or arbitration, Users should contact the Site through the email suport@cllflex.com to try to reach a solution between the parties.
		<br> <br>
		Complaints regarding the Service will be dealt with within 14 business days of receiving the notice by email sent to suport@cllflex.com or by writing to the address. In the event that the claim is accepted via the Web, the User will have the right to use the Services in accordance with the agreed terms, or the price paid for such Services will be refunded.
	`,
	policy: `
		CllFlex Privacy Policy <br> <br>
		Parties Involved <br> <br>
		CllFlex: Computational management system in which companies or individuals can create accounts to manage their activities, such as registration and profile management. CllFlex is responsible for its developer and maintainer.
		Account Holder or Account Holder: Understood as the company or individual that creates an account in the system with the purpose of registering and making available the profile registration in the system. In addition to the Profiles' register, she will have other resources available to manage her activities. The identification of the Account Holder is the sole responsibility of the individual who performs the account registration, and is not certified or guaranteed by CllFlex;
		Profiles: Registration of natural persons or company. Profile registration can take on different types, such as Candidates, Suppliers, Employees, etc. The Account Holder may register profiles directly on the account or provide or send a link to the registration by the profile owner.
		Pefil owner: natural person or company that actually holds personal or business data inserted in the profile.
		<br> <br>
		Considerations: <br>
		Profiles entered for a given account in the system are not shared with other accounts. Each Account Holder has its own Profiles', registered, separated exclusively and restricted only to its own users;
		When creating a profile through external link access, a profile user will be created in the account that originated the registration link.
		<br> <br>
		Introduction
		CllFlex is only responsible for storing profile data on its servers and making them available through its system to the Account Holder, but at no time will it use them and will never share anything with anyone, excluding case of mere use for system maintenance. Your data will be available to users of the account in the system belonging to the Account Holder, who will be responsible for its use in their own terms of use and privacy for which the CllFlex system is neither responsible nor author.
		<br>
		The information we collect
		<br> <br>
		The information collected in the registration form is defined by the configuration of profiles in the system and is the responsibility of the Account Holder. Profile data will be stored on database servers.
		<br> <br>

		The Legal Basis for the Treatment of your Personal Data
		<br> <br>
		Under the GDPR, the main reasons on which we rely on the treatment of the personal information of clients and candidates are as follows:
		<br> <br>
		(a) Need for system maintenance - The only possible use by CllFlex of the data of the registered profiles is only for the maintenance of the system, without any sharing or individual use of the data, being treated only as records in a database without any value or interest in the information related to each record .;
		<br> <br>
		(b) Necessary to fulfill a legal obligation - we are subject to certain legal requirements that may require us to process your personal data. We may also be required, by law, to disclose your personal data to a regulator or law enforcement service;
		<br> <br>
		(d) Consent - in some circumstances, we may ask for your consent to process your personal data in a specific way.
		<br> <br>
		How long will we keep your information
		<br> <br>
		The length of time we hold or store your personal information will depend on the Account Holder. If the Account Holder refuses to delete the data when requested by the profile owner, the Profile Owner may request (with proper identification) the deletion directly by CllFlex. At first, CllFlex will make the request to the Account Holder and, if it does not proceed with the due exclusion, CllFlex will be able to carry out the action directly, through formal confirmation and presentation of legally valid identification documentation.
		<br>
		Aggregate information about the Companies' online visitors
		<br>

		We collect information and statistics collectively on all visitors to our website and the websites of all Group companies:
		<br> <br>
		What areas do users access most often; and / or
		Which services users access most often.
		<br> <br>
		We only use such data in an aggregate manner. This information helps us determine what is most beneficial to our users and how we can continuously improve our online services to create a better overall experience for our users.
		<br> <br>
		We also publish this information on the websites of Group companies and Companies worldwide.
		<br> <br>
		We use Hotjar to better understand the needs of our users and to optimize our service and their experience. Hotjar is a technology service that helps us to better understand the experience of our users (eg the time they spend on which pages, which links they click on, what users like and dislike, etc.) and this allows us to develop and maintain our service with feedback from our users. Hotjar uses cookies and other technologies to collect data about the behavior of our users and their devices (specifically the device's IP address (captured and stored only anonymously), device screen size, device type (unique device identifiers) ), browser information, geographic location (country only), preferred language used to display our website). Hotjar stores this information in a user profile under a pseudonym. Neither Hotjar nor we will ever use this information to identify individual users or to combine it with additional data for an individual user.
		<br> <br>

		Use of Cookies
		<br> <br>
		As with most websites, when you visit our websites, we place cookies on your computer or other device. For the most part, these cookies are used to enable the functionality of websites, improve the user experience and help us optimize our websites, measure traffic and other internal management purposes.
		<br> <br>
		We carry out targeted and relevant banner advertising on several white list websites worldwide to provide you with jobs and content that we think may be of interest to you. We target these ads based on your past interactions with our website, with our emails and through your communications with our consultants. Your interaction with our advertising may be used to measure the effectiveness of our advertising campaigns and to improve our marketing strategy, according to our legitimate interests. No advertising campaign or advertising tracking technology records your personally identifiable information.
		<br> <br>
		Claims
		<br> <br>
		If you are not satisfied with the use of our part of your personal information, you can contact us using the details in the contact section of the website. You also have the right to file a complaint with the Data Protection Authority using any of the contact methods below:
		<br> <br>
		Phone: +351 924402025
		<br>
		Website: https://www.cnpd.pt/
		<br>
		Mail: National Data Protection Commission - CNPD
		<br>
		R. de São. Bento, 148-3 °
		1200-821 Lisbon
		<br>
		If you live or work outside of Portugal, or have a complaint about our activities outside of Portugal, you may prefer to file a complaint with another supervisory authority. A list of relevant authorities in the EEA and the European Free Trade Area can be accessed here.
	`
}

export default en;

